import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// Shared Genesis snapshot: one fetch per minute for every surface; countdown ticks from server time.
let cache = null;
let offsetMs = 0; // server_time - Date.now()
let inflight = null;
const listeners = new Set();

async function load() {
  if (inflight) return inflight;
  inflight = api.genesis().then((d) => {
    offsetMs = new Date(d.server_time).getTime() - Date.now();
    cache = d;
    listeners.forEach((l) => l(d));
    return d;
  }).catch(() => { cache = cache || false; listeners.forEach((l) => l(cache)); return cache; }).finally(() => { inflight = null; });
  return inflight;
}

export const serverNow = () => Date.now() + offsetMs;

export function statusFor(data, now) {
  if (!data || !data.verified) return data ? data.status : null;
  const start = new Date(data.terms.start_at).getTime();
  const end = new Date(data.terms.end_at).getTime();
  return now < start ? "upcoming" : now < end ? "active" : "ended";
}

export function countdownTo(iso, now) {
  const total = Math.max(0, new Date(iso).getTime() - now);
  const s = Math.floor(total / 1000);
  return { total, d: Math.floor(s / 86400), h: Math.floor((s % 86400) / 3600), m: Math.floor((s % 3600) / 60), s: s % 60 };
}

export function useGenesis({ tick = true } = {}) {
  const [data, setData] = useState(cache);
  const [now, setNow] = useState(serverNow());
  useEffect(() => {
    listeners.add(setData);
    if (!cache) load();
    const poll = setInterval(load, 60000);
    return () => { listeners.delete(setData); clearInterval(poll); };
  }, []);
  useEffect(() => {
    if (!tick) return undefined;
    const t = setInterval(() => setNow(serverNow()), 1000);
    return () => clearInterval(t);
  }, [tick]);
  const status = statusFor(data || null, now);
  const target = status === "upcoming" ? data?.terms?.start_at : status === "active" ? data?.terms?.end_at : null;
  return { data: data || null, loading: data === null, failed: data === false, status, now, countdown: target ? countdownTo(target, now) : null };
}
